var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLaunch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.637 10.638v-4.72h1.362v4.72q0 .54-.411.95-.412.412-.95.412H1.362q-.57 0-.967-.396A1.32 1.32 0 0 1 0 10.638V1.362q0-.57.396-.967Q.792 0 1.363 0h4.553v1.363H1.363v9.275zM12 0H7.28l-.001 1.362h2.408L3.065 7.984l.95.95 6.622-6.622v2.409H12z"
})));
export default SvgLaunch;